import { loginRequest } from "../../user/services/auth.services";


export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const DEVICE_TOKEN = "DEVICE_TOKEN";

export const loginUser = (data, history) => {
  return async (dispatch) => {
    try {
      let result = await loginRequest(data);
      dispatch({
        type: LOGIN_USER_SUCCESS,
        payload: result.data,
      });
      if (result.data?.isAdmin) {
        history.push("/home");
      } else {
        history.push("/selectteam");
      }
    } catch (e) {
      console.error("Error during login:", e);
    }
  };
};


